import { tvpil } from '../compat/tvpil';
import { queryKeys } from '../queryKeys';

import { fetchPersonalLineup } from './queryFunctions';

type CreatePersonalLineupQueryOptionsArgs = {
  listType: number;
  staleTime?: number;
};

export function createPersonalLineupQueryOptions({ listType, staleTime }: CreatePersonalLineupQueryOptionsArgs) {
  return {
    queryKey: queryKeys.personalLineup,
    queryFn: () => fetchPersonalLineup({ listType }),
    staleTime: staleTime ?? tvpil.rootStore.channelPersonalizationTtl,
  };
}
